import _, { isEmpty } from "lodash";
import React, { useCallback, useMemo } from "react";
import { CellRenderers, columnRenderArrayData } from "utils/tableUtils";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import {
  GenericIntegrationTicketDefaultValues,
  GenericIntegrationTicketSystemListingProps,
} from "../genericIntegrationTicketConstants";

function AsanaIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = _.filter(
      columns,
      (col) => !["projectKey"].includes(col.dataIndex),
    ).map((col: any) => {
      if (col.dataIndex === "issueType") {
        col.render = (
          issueType: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          const issueTypeValue =
            record.configMetaData?.issueTypeMetaData?.name ?? issueType;
          return CellRenderers.VALUE_OR_NA(issueTypeValue);
        };
      }
      return col;
    });
    return updatedColumns;
  }, []);

  const extraColumns = useMemo(
    () => [
      {
        title: "Workspace",
        dataIndex: "organisationName",
        render: CellRenderers.VALUE_OR_NA,
        width: 130,
      },
    ],
    [],
  );
  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        extraColumns={extraColumns}
        {...props}
      />
    </div>
  );
}

export default AsanaIntegrationListing;
